import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { OnboardingSpotlight, OnboardingStepKeyEnum, useOnboardingFlattenedTour } from "../../../components/Onboarding";
import { setOrganizationOnboardSettings } from "../../../redux/slices/organization";
import store from "../../../redux/store";
import * as def from "./SettingsSidenavGuide.def";

export function SettingsSidenavGuide(props: def.SettingsSidenavGuideProps) {
   
    
    const navigate = useNavigate();
    const location = useLocation();
    

    // Onboarding Steps

    const { onboardSettings = {} } = useSelector((s: any) => s.organization);

    const pmTools: Record<string, boolean> = (onboardSettings?.pm_tools ||
      {}) as any;

    const completedSet = new Set<string>(
      Object.entries(pmTools)
        .filter(([, v]) => !!v)
        .map(([k]) => k),
    );

    const showSideNavOnboarding = useMemo(() => {
      if (location.pathname.includes("#")) return null;

      const settingsEligibleKeys = [
        OnboardingStepKeyEnum.Integrations,
        OnboardingStepKeyEnum.OrgSkills,
        OnboardingStepKeyEnum.OrgHolidays,
      ];

      const currentKey = onboardSettings?.current_navigation;
      const eligibleKeys = [...settingsEligibleKeys];
      const shouldShow = eligibleKeys.includes(currentKey);

      if (!shouldShow) return null;

      if (currentKey === OnboardingStepKeyEnum.Integrations)
        return {
          ref: props.refs.integrationSettingLinkRef,
          navigate: "/settings#Integrations",
          message: "This is where you can manage your integrations",
          offsetToAdd: 2,
        };

      if (currentKey === OnboardingStepKeyEnum.OrgSkills)
        return {
          ref: props.refs.skillsSettingLinkRef,
          navigate: "/settings#OrgSkills",
          message: "This is where you can manage your Organization's skills",
          offsetToAdd: 2,
        };

      if (currentKey === OnboardingStepKeyEnum.OrgHolidays)
        return {
          ref: props.refs.holidaySettingLinkRef,
          navigate: "/settings#Schedules",
          message: "This is where you can manage your Organization's holidays",
          offsetToAdd: 2,
        };

      return null;
    }, [onboardSettings?.current_navigation, props.refs]);

    const { totalSteps: globalTotal, getIndexForProvider } =
      useOnboardingFlattenedTour();

    return (
      showSideNavOnboarding && showSideNavOnboarding.ref && (
        <OnboardingSpotlight
          targetRef={showSideNavOnboarding.ref}
          message={showSideNavOnboarding.message}
          onDismiss={async () => {
            navigate(showSideNavOnboarding.navigate);
          }}
          onClose={()=>{
            const next = onboardSettings || {};

            store.dispatch(setOrganizationOnboardSettings({...next, current_navigation: null, current_location: null}))
          }}
          onSkip={() => {}}
          type="one_time_next"
          
          preferredPlacements={["right"]}
        />
      )
    );
}